import { Phone, Mail, MapPin, Clock, Instagram, Facebook } from "lucide-react";
import { Logo } from "./shared";

export const Footer = () => (
  <footer className="border-t border-white/5 bg-[#07080A]" data-testid="landing-footer">
    <div className="mx-auto grid max-w-7xl gap-10 px-5 py-14 sm:grid-cols-2 lg:grid-cols-4 lg:px-8">
      <div>
        <Logo />
        <p className="mt-5 max-w-xs text-sm leading-relaxed text-zinc-500">
          Especialistas em instalação e manutenção de gás encanado, seguindo a NBR 15526.
          Segurança para sua família e sua empresa.
        </p>
      </div>
      <div>
        <h4 className="font-display text-sm font-bold uppercase tracking-[0.25em] text-[var(--primary)]">Contato</h4>
        <ul className="mt-5 space-y-3.5 text-sm text-zinc-400">
          <li className="flex items-center gap-3">
            <Phone size={16} className="shrink-0 text-[var(--primary)]" /> (11) 98889-1096
          </li>
          <li className="flex items-center gap-3">
            <Mail size={16} className="shrink-0 text-[var(--primary)]" /> contato@Abrinstalmanutentudo.com.br
          </li>
        </ul>
      </div>
      <div>
        <h4 className="font-display text-sm font-bold uppercase tracking-[0.25em] text-[var(--primary)]">Endereço</h4>
        <ul className="mt-5 space-y-3.5 text-sm text-zinc-400">
          <li className="flex items-start gap-3">
            <MapPin size={16} className="mt-0.5 shrink-0 text-[var(--primary)]" />
            R. Rodeio Bonito, 29 - Jardim Coqueiro, Itaquaquecetuba - SP, 08582-630
          </li>
        </ul>
      </div>
      <div>
        <h4 className="font-display text-sm font-bold uppercase tracking-[0.25em] text-[var(--primary)]">Atendimento</h4>
        <ul className="mt-5 space-y-3.5 text-sm text-zinc-400">
          <li className="flex items-center gap-3">
            <Clock size={16} className="shrink-0 text-[var(--primary)]" /> Emergências 24 horas
          </li>
          <li className="flex gap-3 pt-2">
            <a href="https://instagram.com/manutentudoservicos" target="_blank" rel="noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="flex h-9 w-9 items-center justify-center rounded-full border border-white/10 text-zinc-400 transition-colors hover:border-[var(--primary)] hover:text-[var(--primary)]">
              <Instagram size={16} />
            </a>
            <a href="https://www.facebook.com/profile.php?id=61578114742999" target="_blank" rel="noreferrer" data-testid="footer-facebook" aria-label="Facebook" className="flex h-9 w-9 items-center justify-center rounded-full border border-white/10 text-zinc-400 transition-colors hover:border-[var(--primary)] hover:text-[var(--primary)]">
              <Facebook size={16} />
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/5 py-5 text-center text-xs text-zinc-600">
      Manutentudo Serviços © 2026 - Todos os direitos reservados.
    </div>
  </footer>
);
